/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareDependencies } from './dependenciesCompare.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCompareNatural } from '../../factoriesAny.js';
export var compareNaturalDependencies = {
  compareDependencies: compareDependencies,
  typedDependencies: typedDependencies,
  createCompareNatural: createCompareNatural
};